import { RouteRecordRaw } from 'vue-router'

export interface PermissionInfo {
  talent: boolean
  manager: boolean
  hr: boolean
  [key: string]: any
}

export interface PermissionState {
    routes: RouteRecordRaw[]
    dynamicRoutes: RouteRecordRaw[]
    permissionsInfo: PermissionInfo
}

export const state: PermissionState = {
  routes: [],
  dynamicRoutes: [],
  permissionsInfo: {
    talent: false,
    manager: false,
    hr: false
  }
}
